import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Divider, Modal } from 'antd';
import { Box, Grid } from '@mui/material';
import { Watermark } from 'antd';

import { toggleFlightDetail } from '../../reducers/UiReducer';

const FlightDetails = () => {
	const { onwardFlight, flightdetail, returnFlight } = useSelector(
		(state) => state.ui
	);
	const [step, setStep] = useState('fld');
	const dispatch = useDispatch();
	const handleStep = (val) => {
		setStep(val);
	};
	return (
		<div>
			<Modal
				// title='Modal 1000px width'
				centered
				open={flightdetail}
				onOk={() => dispatch(toggleFlightDetail(false))}
				onCancel={() => dispatch(toggleFlightDetail(false))}
				width={1000}>
				<Watermark content='Musafir Bazar'>
					<div className='tabs_wrap'>
						<ul>
							<li
								data-tabs='male'
								onClick={() => handleStep('fld')}
								className={step === 'fld' ? 'active' : ''}>
								Flight Details
							</li>
							<li
								data-tabs='female'
								className={step === 'fd' ? 'active' : ''}
								onClick={() => handleStep('fd')}>
								Fare Details
							</li>
							<li
								onClick={() => handleStep('bag')}
								data-tabs='both'
								className={step === 'bag' ? 'active' : ''}>
								Baggage
							</li>
							<li
								data-tabs='both'
								className={step === 'fr' ? 'active' : ''}
								onClick={() => handleStep('fr')}>
								Fare Rule
							</li>
						</ul>
					</div>
					{step === 'fld' ? (
						<>
							{onwardFlight?.Segments[0]?.map((l) => {
								return (
									<>
										<Box
											display={'flex'}
											justifyContent={'space-between'}
											alignItems={'center'}>
											<Box>
												<img
													src={`https://nitish.musafirbazar.com/static/media/${l.Airline.AirlineCode}.gif`}
												/>
												<span>{l.Airline.AirlineName}</span>
												<p>{`${l.Airline.AirlineCode} - ${l.Airline.FlightNumber}`}</p>
											</Box>
											<Box>
												<h1>{`${l.Origin.Airport.CityName}(${l.Origin.Airport.AirportCode})`}</h1>
												<span>Fri , 20 Oct</span>
												<p>10:00</p>
											</Box>
											<Box>
												<h1>2hr 30 m</h1>
											</Box>
											<Box>
												<h1>{`${l.Destination.Airport.CityName}(${l.Destination.Airport.AirportCode})`}</h1>
												<span>Fri , 20 Oct</span>
												<p>10:00</p>
											</Box>
										</Box>
										<Divider />
									</>
								);
							})}
							{onwardFlight?.Segments[1]?.map((l) => {
								return (
									<>
										<Box
											display={'flex'}
											justifyContent={'space-between'}
											alignItems={'center'}>
											<Box>
												<img
													src={`https://nitish.musafirbazar.com/static/media/${l.Airline.AirlineCode}.gif`}
												/>
												<span>{l.Airline.AirlineName}</span>
												<p>{`${l.Airline.AirlineCode} - ${l.Airline.FlightNumber}`}</p>
											</Box>
											<Box>
												<h1>{`${l.Origin.Airport.CityName}(${l.Origin.Airport.AirportCode})`}</h1>
												<span>Fri , 20 Oct</span>
												<p>10:00</p>
											</Box>
											<Box>
												<h1>2hr 30 m</h1>
											</Box>
											<Box>
												<h1>{`${l.Destination.Airport.CityName}(${l.Destination.Airport.AirportCode})`}</h1>
												<span>Fri , 20 Oct</span>
												<p>10:00</p>
											</Box>
										</Box>
										<Divider />
									</>
								);
							})}
							{returnFlight?.Segments[0]?.map((l) => {
								return (
									<>
										<Box
											display={'flex'}
											justifyContent={'space-between'}
											alignItems={'center'}>
											<Box>
												<img
													src={`https://nitish.musafirbazar.com/static/media/${l.Airline.AirlineCode}.gif`}
												/>
												<span>{l.Airline.AirlineName}</span>
												<p>{`${l.Airline.AirlineCode} - ${l.Airline.FlightNumber}`}</p>
											</Box>
											<Box>
												<h1>{`${l.Origin.Airport.CityName}(${l.Origin.Airport.AirportCode})`}</h1>
												<span>Fri , 20 Oct</span>
												<p>10:00</p>
											</Box>
											<Box>
												<h1>2hr 30 m</h1>
											</Box>
											<Box>
												<h1>{`${l.Destination.Airport.CityName}(${l.Destination.Airport.AirportCode})`}</h1>
												<span>Fri , 20 Oct</span>
												<p>10:00</p>
											</Box>
										</Box>
										<Divider />
									</>
								);
							})}
						</>
					) : step === 'fd' ? (
						<>
							<Grid container style={{ marginTop: 20 }}>
								<Grid item xs={4}>
									<Box
										style={{
											display: 'flex',
											justifyContent: 'space-between',
										}}>
										<h1>Base Fare</h1>
										<span>₹ 8745</span>
									</Box>
									<Box
										mt={1}
										style={{
											display: 'flex',
											justifyContent: 'space-between',
										}}>
										<h1>Airport Tax</h1>
										<span>₹ 8745</span>
									</Box>
									<Box
										mt={1}
										style={{
											display: 'flex',
											justifyContent: 'space-between',
										}}>
										<h1>Grand Total</h1>
										<span>₹ 8745</span>
									</Box>
								</Grid>
								<Grid item xs={6}></Grid>
							</Grid>
						</>
					) : step === 'bag' ? (
						<>
							<Box
								mt={2}
								display={'flex'}
								justifyContent={'space-between'}
								alignItems={'center'}>
								<Box>
									<h1>Flight Sector</h1>
								</Box>
								<Box>
									<h1>Check In Baggage</h1>
								</Box>
								<Box>
									<h1>Cabin In Baggage</h1>
								</Box>
							</Box>
							<Divider />
							{onwardFlight?.Segments[0]?.map((d) => {
								return (
									<>
										<Box
											mt={1}
											display={'flex'}
											justifyContent={'space-between'}
											alignItems={'center'}>
											<Box>
												<h1>{`${d.Origin.Airport.AirportCode} - ${d.Destination.Airport.AirportCode}`}</h1>
											</Box>
											<Box>
												<h1>{d.Baggage}</h1>
											</Box>
											<Box>
												<h1>{d.CabinBaggage}</h1>
											</Box>
										</Box>
										<Divider />
									</>
								);
							})}
							{onwardFlight?.Segments[1]?.map((d) => {
								return (
									<>
										<Box
											mt={1}
											display={'flex'}
											justifyContent={'space-between'}
											alignItems={'center'}>
											<Box>
												<h1>{`${d.Origin.Airport.AirportCode} - ${d.Destination.Airport.AirportCode}`}</h1>
											</Box>
											<Box>
												<h1>{d.Baggage}</h1>
											</Box>
											<Box>
												<h1>{d.CabinBaggage}</h1>
											</Box>
										</Box>
										<Divider />
									</>
								);
							})}
							{returnFlight?.Segments[0]?.map((d) => {
								return (
									<>
										<Box
											mt={1}
											display={'flex'}
											justifyContent={'space-between'}
											alignItems={'center'}>
											<Box>
												<h1>{`${d.Origin.Airport.AirportCode} - ${d.Destination.Airport.AirportCode}`}</h1>
											</Box>
											<Box>
												<h1>{d.Baggage}</h1>
											</Box>
											<Box>
												<h1>{d.CabinBaggage}</h1>
											</Box>
										</Box>
										<Divider />
									</>
								);
							})}
						</>
					) : (
						''
					)}
				</Watermark>
			</Modal>
		</div>
	);
};

export default FlightDetails;
